//Custom components
import type { IType } from '@/api/Rover/types';
import { transformProjectTypeChartDataSets } from '@/utils';
import Card from '../../../UI/Card/index.tsx';
import PieChart from '../../../UI/Charts/PieChart';

export interface BreakdownProps {
  title: string;
  breakdownAcquisition: IType[];
}

export default function BreakdownAcquisitionType(props: BreakdownProps) {
  const { title, breakdownAcquisition } = props;

  const acquisitionTypeLabels = breakdownAcquisition?.map((data: IType) => data?.acquisitionType);

  const projectsByAcquisitionType = breakdownAcquisition?.map((data: IType) => {
    return {
      type: data?.constructionType,
      count: data?._count?.acquisitionType,
    };
  });

  const totalAcquisitionType = breakdownAcquisition?.reduce((acc: number, data: IType) => {
    return acc + data?._count?.acquisitionType;
  }, 0);

  return (
    <Card title={title}>
      <div className='relative p-5 h-80'>
        <div className='absolute px-5 text-center'>
          <h3 className='text-gray-500 font-bold'>Total Projects</h3>
          <h1 className='m-0'>{totalAcquisitionType}</h1>
        </div>
        <div className='md:w-7/8 xl:w-full h-full'>
          <PieChart
            labels={acquisitionTypeLabels}
            datasets={transformProjectTypeChartDataSets(projectsByAcquisitionType)}
            chartTitle='Total Project Types'
          />
        </div>
      </div>
    </Card>
  );
}
